export default __webpack_public_path__ + "static/media/8d1fa4730bf0b8ff9ca40936ab9a139f.2e945842.png";